module.exports = __webpack_public_path__ + "static/media/medicine-spoon.6ae26323.svg";